<svg width="14" height="2" viewBox="0 0 14 2" xmlns="http://www.w3.org/2000/svg"><path d="M14 1a1 1 0 01-1 1H1a1 1 0 110-2h12a1 1 0 011 1z"/></svg>